import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

import 'brace';
import 'brace/mode/json';
import 'brace/mode/html';
import 'brace/mode/markdown';
import 'brace/theme/dracula';
import { AceComponent, AceModule } from 'ngx-ace-wrapper';
import { debounceTime } from 'rxjs/operators';
import { untilDestroyed } from '@jump-tech-frontend/angular-common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-html-section',
    template: `
    <form [formGroup]="form">
      <ace
        style="height: 100px"
        [mode]="'html'"
        [theme]="'dracula'"
        [value]="value"
        (change)="onValueChange(aceEditor)"
        #aceEditor
      >
      </ace>
    </form>
  `,
    imports: [ReactiveFormsModule, AceModule]
})
export class HtmlTypeComponent extends FieldType implements OnInit {
  private _value;
  private untilDestroyed = untilDestroyed();

  get value() {
    return this._value;
  }

  ngOnInit() {
    this._value = this.formControl.value;
    this.formControl.valueChanges.pipe(debounceTime(1000), this.untilDestroyed()).subscribe(value => {
      this._value = value;
    });
  }

  onValueChange(aceEditor: AceComponent) {
    setTimeout(() => {
      try {
        this.formControl.patchValue(aceEditor?.value ?? null);
        this.form.updateValueAndValidity();
      } catch (e) {
        // Do nothing as code input is invalid.
      }
    }, 0);
  }
}
